export default {
  path: '/store-card-apply',
  meta: {
    title: '提货记录',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-card-apply`),
}



// WEBPACK FOOTER //
// ./src/views/StoreCardApplyList/router.js